module.exports = __webpack_public_path__ + "img/writing.375b81b.jpg";